import { integer, pgEnum, pgTable, text, timestamp, uuid } from "drizzle-orm/pg-core";
import { endUsers } from "../app";
import { catalogItems } from "./catalog-item";

export const procurementTypeEnum = pgEnum("procurement_type", ["RETOOL", "RECEIVE_FALLBACK"]);

export const procurementStatusEnum = pgEnum("procurement_status", [
  "OPEN",
  "ORDERED",
  "UNFULFILLABLE",
  "CANCELLED",
  "RECEIVED",
  "PARTIALLY_RECEIVED",
  "DEPLETED",
]);

/**
 * @deprecated Boxed lot-array port. Unused at runtime; drop in a later unsafe-ok
 * migration once nothing references the table.
 */
export const procurementRequests = pgTable("procurement_requests", {
  id: uuid("id").primaryKey().defaultRandom(),
  itemId: uuid("item_id")
    .notNull()
    .references(() => catalogItems.id),
  type: procurementTypeEnum("type").notNull(),
  status: procurementStatusEnum("status").notNull(),
  quantity: integer("quantity").notNull(),
  categoryId: uuid("category_id"),
  vendorId: uuid("vendor_id"),
  procurementOrderId: uuid("procurement_order_id"),
  endUserId: text("end_user_id").references(() => endUsers.id),
  urgency: integer("urgency"),
  dueAt: timestamp("due_at", { withTimezone: true }).notNull(),
  orderedAt: timestamp("ordered_at", { withTimezone: true }),
  purchasePrices: integer("purchase_prices").array().notNull().default([]),
  availablePrices: integer("available_prices").array().notNull().default([]),
  depletedPrices: integer("depleted_prices").array().notNull().default([]),
  notes: text("notes"),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
});
